import { render } from "./CustomizerHeader.vue?vue&type=template&id=40feccd2&scoped=true"
import script from "./CustomizerHeader.vue?vue&type=script&lang=js"
export * from "./CustomizerHeader.vue?vue&type=script&lang=js"

import "./CustomizerHeader.vue?vue&type=style&index=0&id=40feccd2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40feccd2"]])

export default __exports__